import React, { useState, useEffect } from 'react';

// Yerel veri
const initData = {
    text: "Socia ile şehirdeki tüm etkinlikleri keşfedin, ilgi alanlarınıza göre öneriler alın ve sosyal hayatınızı zenginleştirin.",
    linkText_1: "Hızlı Erişim",
    linkText_2: "Yardım",
    linkText_3: "İndir"
};

// Yerel sosyal medya simgeleri
const iconList = [
    {
        "id": 1,
        "link": "https://www.instagram.com/socia_tr/",
        "iconClass": "fab fa-instagram",
        "className": "instagram" // Ekledik - CSS için
    },
    {
        "id": 2,
        "link": "https://x.com/Socia_tr",
        "iconClass": "fab fa-x-twitter",
        "className": "twitter" // Ekledik - CSS için
    },
    {
        "id": 3,
        "link": "https://www.linkedin.com/company/thesociapp/",
        "iconClass": "fab fa-linkedin-in",
        "className": "linkedin" // Ekledik - CSS için
    },
    {
        "id": 4,
        "link": "mailto:info@thesocia.co",
        "iconClass": "fa fa-envelope",
        "className": "gmail" // Ekledik - CSS için
    }
];

// Güncellenmiş hızlı erişim bağlantıları
const footerList_1 = [
    {
        id: 1,
        text: "Ana Sayfa",
        link: "#" // Yukarı scroll etmek için
    },
    {
        id: 2,
        text: "Hakkımızda",
        link: "#features" // Features section'a scroll
    },
    {
        id: 3,
        text: "Özellikler",
        link: "#work" // Work section'a scroll
    }
];

// Güncellenmiş yardım bağlantıları
const footerList_2 = [
    {
        id: 1,
        text: "Sıkça Sorulan Sorular",
        link: "/faq"
    },
    {
        id: 2,
        text: "Gizlilik Politikası",
        link: "/privacy-policy"
    },
    {
        id: 3,
        text: "KVKK / Aydınlatma Metni",
        link: "/terms"
    },
    {
        id: 4,
        text: "Hesap Silme",
        link: "/account-deletion"
    }
];

// Yerel indirme bağlantıları
const footerList_3 = [
    {
        id: 1,
        image: "/img/google-play-black.png",
        link: "https://play.google.com/store/apps/details?id=com.sociaapp"
    },
    {
        id: 2,
        image: "/img/app-store-black.png",
        link: "https://apps.apple.com/app/socia/id1234567890"
    }
];

const FooterSection = () => {
    const [data, setData] = useState({});
    const [icons, setIcons] = useState([]);
    const [links1, setLinks1] = useState([]);
    const [links2, setLinks2] = useState([]);
    const [links3, setLinks3] = useState([]);

    useEffect(() => {
        // API yerine yerel sabitlerden veri ayarlama
        setData(initData);
        setIcons(iconList);
        setLinks1(footerList_1);
        setLinks2(footerList_2);
        setLinks3(footerList_3);
    }, []);

    // Link tıklamaları için scroll işlemi
    const handleScroll = (e, target) => {
        e.preventDefault();
        
        if (target === 'top') {
            // Sayfa başına scroll
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } else if (target === 'features') {
            // Features bölümüne scroll
            const featuresSection = document.getElementById('features');
            if (featuresSection) {
                featuresSection.scrollIntoView({ behavior: 'smooth' });
            }
        } else if (target === 'work') {
            // Work bölümüne scroll
            const workSection = document.querySelector('.work-area');
            if (workSection) {
                workSection.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    return (
        <div>
            <div className="height-emulator d-none d-lg-block" />
            <footer className="footer-area footer-fixed">
                {/* Footer Top */}
                <div className="footer-top ptb_100">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-6 col-lg-3">
                                {/* Footer Items */}
                                <div className="footer-items">
                                    {/* Logo */}
                                    <a className="navbar-brand" href="/">
                                        <img className="logo" src='/img/logo-white.png' alt="" />
                                    </a>
                                    <p className="mt-2 mb-3">{data.text}</p>
                                    {/* Social Icons */}
                                    <div className="social-icons d-flex">
                                        {icons.map((item, idx) => (
                                            <a
                                                key={`fi_${idx}`}
                                                className={item.className}
                                                href={item.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className={item.iconClass} />
                                                <i className={item.iconClass} />
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                {/* Footer Items */}
                                <div className="footer-items">
                                    {/* Footer Title */}
                                    <h3 className="footer-title mb-2">{data.linkText_1}</h3>
                                    <ul>
                                        {/* Anasayfa - Yukarı scroll */}
                                        <li className="py-2">
                                            <a href="#" onClick={(e) => handleScroll(e, 'top')}>Ana Sayfa</a>
                                        </li>
                                        {/* Hakkımızda - Features'a scroll */}
                                        <li className="py-2">
                                            <a href="#features" onClick={(e) => handleScroll(e, 'features')}>Hakkımızda</a>
                                        </li>
                                        {/* Özellikler - Work'e scroll */}
                                        <li className="py-2">
                                            <a href="#work" onClick={(e) => handleScroll(e, 'work')}>Özellikler</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                {/* Footer Items */}
                                <div className="footer-items">
                                    {/* Footer Title */}
                                    <h3 className="footer-title mb-2">{data.linkText_2}</h3>
                                    <ul>
                                        {links2.map((item, idx) => (
                                            <li key={`flt_${idx}`} className="py-2">
                                                <a href={item.link}>{item.text}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                {/* Footer Items */}
                                <div className="footer-items">
                                    {/* Footer Title */}
                                    <h3 className="footer-title mb-2">{data.linkText_3}</h3>
                                    {/* Store Buttons */}
                                    <div className="button-group store-buttons store-black d-flex flex-wrap">
                                        {links3.map((item, idx) => (
                                            <a key={`flth_${idx}`} href={item.link} target="_blank" rel="noopener noreferrer">
                                                <img src={item.image} alt="" />
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer Bottom */}
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                {/* Copyright Area */}
                                <div className="copyright-area d-flex flex-wrap justify-content-center justify-content-sm-between text-center py-4">
                                    {/* Copyright Left */}
                                    <div className="copyright-left">© 2024 Socia. Tüm hakları saklıdır.</div>
                                    {/* Copyright Right */}
                                    <div className="copyright-right">Sevgiyle <i className="fas fa-heart" /> geliştiren <a target="_blank" rel="noopener noreferrer" href="mailto:tolgakarabudak2@gmail.com">Socia Ekibi</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default FooterSection;